/**
 * Script 命名空间
 * 用于脚本相关的 trigger 类型前缀
 */
export const scriptTriggerNamespace = 'fanfanlo/javajs/v1/project/components/triggers/script/'
